import { Form } from '@mairistem/composants';
import { formatMonetaire } from '@/utils';

interface NumeraireProps {
  montant: number;
}

const Numeraire = (props: NumeraireProps) => {
  const { montant: montantProps } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Numéraire</label>
      </Form.Field>
      <Form.Field
        inline
        width={14}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Numeraire;
